import "./styles/frontend.scss";
import "./styles/animations.scss";
import "./styles/colours.scss";
import "./styles/globals.scss";
import "./styles/newsletter.scss";
import "./styles/page.scss";
import "./styles/post.scss";
import "./styles/userway.scss";
import "./scripts/animations.js";
import "./scripts/scroll.js";
import "./scripts/translation.js";
import "../../template-parts/header/header.scss";
import "../../template-parts/header/header.js";
import "../../template-parts/call-to-action/call-to-action.js";
import "../../template-parts/dialog/dialog.js";
import "../../template-parts/featured-articles/featured-articles.scss";
import "../../template-parts/featured-articles/featured-articles.js";
import "../../template-parts/form/form.scss";
import "../../template-parts/footer/footer.scss";
import "../../template-parts/footer/footer.js";
import "../../template-parts/hero/hero.js";
import "../../template-parts/hero/hero-slide.scss";
import "../../template-parts/image/image.js";
import "../../template-parts/image/image.scss";
import "../../template-parts/logo-slider/logo-slider.scss";
import "../../template-parts/logo-slider/logo-slider.js";
import "../../template-parts/quotes/quote.js";
import "../../template-parts/quotes/quotes.scss";
import "../../template-parts/search-bar/search-bar.js";
import "../../template-parts/tabbed-content/tabbed-content.js";
import "../../template-parts/tabbed-content/tabbed-content.scss";
import "../../template-parts/text/text.scss";
import "../../template-parts/two-column-text/two-column-text.scss";
